import React from 'react';
import { Button, Popover, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import preserveInputFocus from './preserveInputFocus.js';
import ComposerActionMenu from './ComposerActionMenu.jsx';
import ComposerModeStrip from './ComposerModeStrip.jsx';
import ComposerSubmitAction from './ComposerSubmitAction.jsx';
import ComposerTargetChip from './ComposerTargetChip.jsx';
import { MESSAGE_ATTACHMENT_ACCEPT_ATTR } from './composerShared.jsx';

export default function ComposerActionRow({
  attachLabel,
  disabled,
  fileInputRef,
  handleFileSelect,
  loading,
  modeButtonAnimatingKey,
  modeButtonAnimationTimerRef,
  modeStatusByKey,
  modeValue,
  onAbort,
  onModeChange,
  onSend,
  onTargetDismiss,
  quickModeEntries,
  sendDisabled,
  sendLabel,
  setModeButtonAnimatingKey,
  setToolMenuOpen,
  stopLabel,
  submitting,
  targetChip,
  themeTokens,
  toolMenuOpen,
}) {
  const blocked = Boolean(disabled || loading || submitting);
  return (
    <div
      style={{
        alignItems: 'flex-end',
        display: 'grid',
        gap: 6,
        gridTemplateColumns: 'minmax(0,1fr) auto',
        marginTop: 8,
        width: '100%',
      }}
    >
      <Space align="center" size={8} wrap>
        <Popover
          arrow={false}
          content={(
            <ComposerActionMenu
              fileInputRef={fileInputRef}
              disabled={blocked}
              quickModeEntries={quickModeEntries}
              modeValue={modeValue}
              onModeChange={onModeChange}
              setToolMenuOpen={setToolMenuOpen}
            />
          )}
          open={toolMenuOpen}
          overlayClassName="flare-composer-menu-popover"
          classNames={{ root: 'flare-composer-menu-popover' }}
          placement="topLeft"
          styles={{ body: { background: 'transparent', boxShadow: 'none', padding: 0 } }}
          trigger="click"
          onOpenChange={(open) => {
            if (!blocked) {
              setToolMenuOpen(open);
            }
          }}
        >
          <Button
            className="flare-attach-button"
            disabled={blocked}
            icon={<PlusOutlined />}
            onMouseDown={preserveInputFocus}
            style={{ color: themeTokens.textSecondary }}
            title={attachLabel}
            type="text"
          />
        </Popover>
        <input
          accept={MESSAGE_ATTACHMENT_ACCEPT_ATTR}
          disabled={blocked}
          hidden
          multiple
          onChange={handleFileSelect}
          ref={fileInputRef}
          type="file"
        />
        <ComposerModeStrip
          disabled={blocked}
          modeButtonAnimatingKey={modeButtonAnimatingKey}
          modeButtonAnimationTimerRef={modeButtonAnimationTimerRef}
          modeStatusByKey={modeStatusByKey}
          modeValue={modeValue}
          onModeChange={onModeChange}
          quickModeEntries={quickModeEntries}
          setModeButtonAnimatingKey={setModeButtonAnimatingKey}
        />
        <ComposerTargetChip
          chip={targetChip}
          onDismiss={onTargetDismiss}
          themeTokens={themeTokens}
        />
      </Space>
      <Space align="center" size={8}>
        <ComposerSubmitAction
          disabled={disabled}
          loading={loading}
          onAbort={onAbort}
          onSend={onSend}
          sendDisabled={sendDisabled}
          sendLabel={sendLabel}
          submitting={submitting}
          stopLabel={stopLabel}
        />
      </Space>
    </div>
  );
}
